import { useSelector } from 'react-redux';
import {
  selectIsSearchMetaTooltipAvailable,
  selectLastAppliedFilter,
  selectOpenedFilter,
} from 'shared/selectors/searchMetaTooltip';
import { TFilter } from 'shared/types/filters';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useShowSearchMetaTooltip = (filterKey: TFilter) => {
  const {
    custom: { applyFilterAfterChange },
  } = useApplicationContext();

  const isTooltipAvailable = useSelector(selectIsSearchMetaTooltipAvailable);
  const lastAppliedFilter = useSelector(selectLastAppliedFilter);
  const openedFilter = useSelector(selectOpenedFilter);

  const currentFilterIsLastApplied = lastAppliedFilter === filterKey;

  const currentFilterIsOpened = openedFilter === filterKey;

  return (
    !applyFilterAfterChange &&
    isTooltipAvailable &&
    currentFilterIsLastApplied &&
    (!openedFilter || currentFilterIsOpened)
  );
};
